
import Vue from 'vue'

export default Vue.extend({
   name: 'AlertComponent',
   props: {
      title: { default: '', type: String },
      message: { default: '', type: String },
      type: { default: 'info', type: String },
      icon: { default: '', type: String },
   },
   computed: {
      typeClass(): string {
         return `alert-${this.type}`
      },
   },
})
